var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6, _linearGradient7, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "256px",
    height: "256px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "UC11dU6fpD1Whu1sZEZF0a",
    x1: 14.296,
    x2: 14.296,
    y1: 42.833,
    y2: 53.022,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#UC11dU6fpD1Whu1sZEZF0a)",
    d: "M11.702,43.702l6.596,6.596C18.926,50.926,18.481,52,17.593,52H12c-1.105,0-2-0.895-2-2 v-5.593C10,43.519,11.074,43.074,11.702,43.702z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "UC11dU6fpD1Whu1sZEZF0b",
    x1: 32,
    x2: 32,
    y1: 8,
    y2: 55.938,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#UC11dU6fpD1Whu1sZEZF0b)",
    d: "M55,20h-1v-6c0-1.654-1.346-3-3-3v-1c0-1.103-0.897-2-2-2H15c-1.103,0-2,0.897-2,2v1 c-1.654,0-3,1.346-3,3v6H9c-1.654,0-3,1.346-3,3v6v1v21c0,2.757,2.243,5,5,5h42c2.757,0,5-2.243,5-5V31v-2v-6 C58,21.346,56.654,20,55,20z M55,22c0.552,0,1,0.448,1,1v2.026c-0.584-0.442-1.257-0.773-2-0.925V22H55z M15,10h34v1H15V10z M13,13 h38c0.552,0,1,0.448,1,1v10h-9.929c-1.007,0-1.94,0.5-2.497,1.337l-2.813,4.218C36.575,29.833,36.265,30,35.929,30h-7.857 c-0.336,0-0.646-0.167-0.833-0.446l-2.813-4.216C23.869,24.5,22.936,24,21.929,24H12V14C12,13.448,12.448,13,13,13z M9,22h1v2.101 c-0.743,0.152-1.416,0.482-2,0.925V23C8,22.448,8.448,22,9,22z M56,51c0,1.654-1.346,3-3,3H11c-1.654,0-3-1.346-3-3V30v-1 c0-1.654,1.346-3,3-3h10.929c0.336,0,0.646,0.167,0.833,0.446l2.813,4.216C26.131,31.5,27.064,32,28.071,32h7.857 c1.007,0,1.94-0.5,2.497-1.337l2.813-4.218C41.425,26.167,41.735,26,42.071,26H53c1.654,0,3,1.346,3,3v2V51z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "UC11dU6fpD1Whu1sZEZF0c",
    x1: 33,
    x2: 33,
    y1: 8,
    y2: 55.938,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#UC11dU6fpD1Whu1sZEZF0c)",
    d: "M21 17H45V19H21z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "UC11dU6fpD1Whu1sZEZF0d",
    x1: 49,
    x2: 49,
    y1: 8,
    y2: 55.938,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#UC11dU6fpD1Whu1sZEZF0d)",
    d: "M44 50H54V52H44z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "UC11dU6fpD1Whu1sZEZF0e",
    x1: 49,
    x2: 49,
    y1: 8,
    y2: 55.938,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#UC11dU6fpD1Whu1sZEZF0e)",
    d: "M44 46H54V48H44z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "UC11dU6fpD1Whu1sZEZF0f",
    x1: 32,
    x2: 32,
    y1: 8,
    y2: 55.938,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#UC11dU6fpD1Whu1sZEZF0f)",
    d: "M27 21H37V23H27z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "UC11dU6fpD1Whu1sZEZF0g",
    x1: 32,
    x2: 32,
    y1: 8,
    y2: 55.938,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#UC11dU6fpD1Whu1sZEZF0g)",
    d: "M29 25H35V27H29z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.18f50f99eaa6bb3fd52ae86cf3338e06.svg";
export { ForwardRef as ReactComponent };